import { Box, Paper, Stack, Typography } from '@mui/material'
import { DashboardSnapshotDto, TimeToXDto } from '../../../interfaces/IDashboard'
import { usePolling } from '../../../hooks/usePolling'
import InfoTooltip from './InfoTooltip'
import KpiBigNumber from './KpiBigNumber'

interface QualityKpiCardProps {
  snapshot: DashboardSnapshotDto | null
  info?: string
}

const HISTORICAL_POLL_INTERVAL_MS = 5 * 60_000

function formatPercent(value: number | null | undefined): string {
  if (value === null || value === undefined) return '–'
  return `${value.toFixed(0)} %`
}

function QualityKpiCard({ snapshot, info }: QualityKpiCardProps) {
  const { data: timeToX } = usePolling<TimeToXDto>('/api/stats/dashboard/time-to-x?window=30d', HISTORICAL_POLL_INTERVAL_MS)
  const snapshotLoaded = snapshot !== null
  const ttxLoaded = timeToX !== null

  const alertSentSublabel =
    snapshotLoaded && (snapshot?.alertsCreatedTotal30d ?? 0) > 0
      ? `${snapshot.alertsCreatedTotal30d} opprettet · ${snapshot.alertsDeletedBeforeSendTotal30d} slettet`
      : undefined

  const reopenedSublabel =
    ttxLoaded && (timeToX?.closedInWindowFFCount ?? 0) > 0
      ? `${timeToX?.reopenedAfterCloseCount ?? 0} av ${timeToX?.closedInWindowFFCount ?? 0} lukket`
      : undefined

  return (
    <Paper elevation={1} sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Kvalitetsmål (30d)
        </Typography>
        {info && <InfoTooltip text={info} />}
      </Stack>
      <Box sx={{ flex: 1, display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1, alignItems: 'center' }}>
        <KpiBigNumber
          label="Alvorlighetsgrad-stabilitet"
          value={ttxLoaded ? formatPercent(timeToX?.criticalityStabilityPercent) : null}
        />
        <KpiBigNumber
          label="Lukket samme dag"
          value={ttxLoaded ? formatPercent(timeToX?.closureSameDayPercent) : null}
        />
        <KpiBigNumber
          label="Varsler fullført"
          value={snapshotLoaded ? formatPercent(snapshot?.alertsSentSharePercent30d) : null}
          sublabel={alertSentSublabel}
        />
        <KpiBigNumber
          label="Gjenåpnet etter lukk"
          value={ttxLoaded ? formatPercent(timeToX?.reopenedAfterCloseSharePercent) : null}
          sublabel={reopenedSublabel}
        />
      </Box>
    </Paper>
  )
}

export default QualityKpiCard
